import apiClient from './apiClient';
import DashboardData from '../models/DashboardData';

class DashboardService {
  async getDashboardData() {
    try {
      console.log('Making dashboard API call to /tasks/analytics/dashboard');
      const response = await apiClient.get('/tasks/analytics/dashboard');
      console.log('Dashboard API response received:', response);
      
      const transformedData = DashboardData.fromJson(response);
      console.log('Transformed dashboard data:', transformedData);
      
      return transformedData;
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      console.error('Error details:', {
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        message: error.message
      });
      throw error;
    }
  }
  
  async getTaskCompletionHistory(days = 30) {
    try {
      const response = await apiClient.get('/dashboard/completion-history', { days });
      return response.map(item => ({
        date: new Date(item.date),
        count: item.count
      }));
    } catch (error) {
      console.error('Error fetching task completion history:', error);
      throw error;
    }
  }

  async getTasksCompletedPerDay(startDate, endDate) {
    try {
      const response = await apiClient.get(`/tasks/analytics/tasks-completed-per-day?startDate=${startDate}&endDate=${endDate}`);
      return response.daily_data || [];
    } catch (error) {
      console.error('Error fetching tasks completed per day:', error);
      throw error;
    }
  }

  async getTaskDurationByCategory(startDate, endDate) {
    try {
      const response = await apiClient.get(`/tasks/analytics/task-duration-by-category?startDate=${startDate}&endDate=${endDate}`);
      return response.category_data || [];
    } catch (error) {
      console.error('Error fetching task duration by category:', error);
      throw error;
    }
  }

  async getTaskCompletionTimeliness(startDate, endDate) {
    try {
      const response = await apiClient.get(`/tasks/analytics/task-completion-timeliness?startDate=${startDate}&endDate=${endDate}`);
      return response;
    } catch (error) {
      console.error('Error fetching task completion timeliness:', error);
      throw error;
    }
  }

  async getCompletionStatusOverTime(startDate, endDate) {
    try {
      const response = await apiClient.get(`/tasks/analytics/completion-status-over-time?startDate=${startDate}&endDate=${endDate}`);
      return response.daily_data || [];
    } catch (error) {
      console.error('Error fetching completion status over time:', error);
      throw error;
    }
  }

  async getAverageDurationPerDay(startDate, endDate) {
    try {
      const response = await apiClient.get(`/tasks/analytics/average-duration-per-day?startDate=${startDate}&endDate=${endDate}`);
      return response.daily_data || [];
    } catch (error) {
      console.error('Error fetching average duration per day:', error);
      throw error;
    }
  }

  async getTasksByHour(startDate, endDate) {
    try {
      const response = await apiClient.get(`/tasks/analytics/tasks-by-hour?startDate=${startDate}&endDate=${endDate}`);
      return response.hourly_data || [];
    } catch (error) {
      console.error('Error fetching tasks by hour:', error);
      throw error;
    }
  }

  async getCompletionHeatmap(startDate, endDate) {
    try {
      const response = await apiClient.get(`/tasks/analytics/completion-heatmap?startDate=${startDate}&endDate=${endDate}`);
      return response;
    } catch (error) {
      console.error('Error fetching completion heatmap:', error);
      throw error;
    }
  }
}

export default new DashboardService(); 